// src/pages/Home/CreateJobPage.tsx
import React, { useEffect } from 'react';
import { Container, Row, Col } from 'reactstrap';
import Header from './Header';
import Footer from './Footer';
import CreateJob from '../DashboardProject/CreateJob';
import { useNavigate } from 'react-router-dom';

const CreateJobPage: React.FC = () => {
    const navigate = useNavigate();

    useEffect(() => {
        document.title = "Create Your Project - BidBro | Get competitive bids from verified contractors";
    }, []);

    const handleJobCreated = (jobId: string) => {
        console.log('Job created with ID:', jobId);
        // Could add analytics tracking here
    };

    return (
        <React.Fragment>
            <Header isFullWidth={true} />
            <div className="min-h-screen bg-white">


                {/* Hero Section */}
                <section className="py-5 bg-light" style={{ marginTop: "80px" }}>
                    <Container>
                        <div className="text-center mb-5">
                            <h1 className="display-4 fw-bold mb-3">Create Your Project</h1>
                            <p className="fs-5 text-muted mb-0">
                                Get competitive bids from qualified contractors in your area
                            </p>
                        </div>
                    </Container>
                </section>

                {/* Main Content */}
                <section className="py-5">
                    <Container fluid>
                        <Row className="justify-content-center">
                            <Col lg={12}>
                                <CreateJob
                                    onJobCreated={handleJobCreated}
                                    showHeader={false}
                                    redirectOnSuccess={false}
                                />
                            </Col>
                        </Row>
                    </Container>
                </section>

                <Footer />
            </div>
        </React.Fragment>
    );
};

export default CreateJobPage;